import React from "react";
import Modal from "../../assets/components/ModalComonent";

const Rules = ({ show, handleClose }) => {
  const rulesDialog = (
    <>
      <div className="w-100">
        <p className="font-weight-bold text-center">قوانین</p>
        <p className="text-right">
          سلام
          <br />
          <br />
          قوانین چالش جفت پوچ:
          <br />
          هر نفر فقط و فقط یک بار میتونه در چالش هفتگی شرکت کنه.
          <br />
          وقتی چالش رو شروع کردی، دیگه باید تا تهش بری؛ چون مثل زندگی دکمه برگشت نداره! 😊
          <br />
          <br />
          چالش هفتگی در ساعت 18:00 هر پنجشنبه فعال میشه و تا ساعت 18:00 روز جمعه فعال میمونه.
          <br />
          <br />
          چالش جفت پوچ یه بازی خاصه. برای همین ادبیاتش هم خاصه. مثلا به جای سکه میگیم پله و به جای لِوِل هم میگیم طبقه و یه چیز دیگه‌ای داریم به نام کلید. اینا همه‌ش توضیح و تفسیر داره که خودت داری میفهمی 😉
هر سؤال که جواب میدی، 10 پله میگیری و طبق فرمول هر چند پله یک طبقه میری بالا
        </p>
      </div>
    </>
  );

  return (
    <Modal open={show} closeHandler={handleClose} dialogContent={rulesDialog} />
  );
};

export default Rules;
